/* eslint-disable no-undef */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ItemService from "../../../services/logistics_appCommonService";

const initialState = {
  transport: {
    data: [],
    status: true,
    transportNr: "",
    workflow: [],
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  vehicle: {
    data: [],
    status: true,
    vehicleNr: "",
    workflow: [],
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  driver: {
    data: [],
    status: true,
    driverNr: "",
    workflow: [],
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  transporter: {
    data: [],
    status: true,
    transporterNr: "",
    workflow: [],
    fuelData:[],
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  bunk: {
    data: [],
    status: true,
    bunkNr: "",
    workflow: [],
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  bank: {
    data: [],
    status: true,
    bankAcNr: "",
    workflow: [],
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
};

export const logisticsSlice = createSlice({
  name: "logistics",
  initialState,
  reducers: {
    addTransportNr(state, action) {
      state.transport.transportNr = action.payload;
    },
    addFuelData(state, action) {
      state.transport.fuelData = action.payload;
    },
    addVehicleNr(state, action) {
      state.vehicle.vehicleNr = action.payload;
    },
    addDriverNr(state, action) {
      state.driver.driverNr = action.payload;
    },
    addTransporterNr(state, action) {
      state.transporter.transporterNr = action.payload;
    },

    addbunkNr(state, action) {
      state.bunk.bunkNr = action.payload;
    },
    bankAcNr(state, action) {
      state.bank.bankAcNr = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTransportList.pending, (state, action) => {
        state.transport.status = true;
      })
      .addCase(getTransportList.fulfilled, (state, action) => {
        state.transport.data = action.payload.data;
        state.transport.pagination.page = action.payload.page;
        state.transport.pagination.per_page = action.payload.per_page;
        state.transport.pagination.total = action.payload.total;
        state.transport.status = false;
      })
      .addCase(getVehicleList.pending, (state, action) => {
        state.vehicle.status = true;
      })
      .addCase(getVehicleList.fulfilled, (state, action) => {
        state.vehicle.data = action.payload.data;
        state.vehicle.pagination.page = action.payload.page;
        state.vehicle.pagination.per_page = action.payload.per_page;
        state.vehicle.pagination.total = action.payload.total;
        state.vehicle.status = false;
      })
      .addCase(getDriverList.pending, (state, action) => {
        state.driver.status = true;
      })
      .addCase(getDriverList.fulfilled, (state, action) => {
        state.driver.data = action.payload.data;
        state.driver.pagination.page = action.payload.page;
        state.driver.pagination.per_page = action.payload.per_page;
        state.driver.pagination.total = action.payload.total;
        state.driver.status = false;
      })
      .addCase(getBunkList.pending, (state, action) => {
        state.bunk.status = true;
      })
      .addCase(getBunkList.fulfilled, (state, action) => {
        state.bunk.data = action.payload.data;
        state.bunk.pagination.page = action.payload.page;
        state.bunk.pagination.per_page = action.payload.per_page;
        state.bunk.pagination.total = action.payload.total;
        state.bunk.status = false;
      })
      .addCase(getTransporterList.pending, (state, action) => {
        state.transporter.status = true;
      })
      .addCase(getTransporterList.fulfilled, (state, action) => {
        state.transporter.data = action.payload.data;
        state.transporter.pagination.page = action.payload.page;
        state.transporter.pagination.per_page = action.payload.per_page;
        state.transporter.pagination.total = action.payload.total;
        state.transporter.status = false;
      })
      .addCase(getBankList.pending, (state, action) => {
        state.bank.status = true;
      })
      .addCase(getBankList.fulfilled, (state, action) => {
        state.bank.data = action.payload.data;
        state.bank.pagination.page = action.payload.page;
        state.bank.pagination.per_page = action.payload.per_page;
        state.bank.pagination.total = action.payload.total;
        state.bank.status = false;
      });
  },
});

export const {
  addTransportNr,
  addVehicleNr,
  addDriverNr,
  addTransporterNr,
  addbunkNr,
  bankAcNr,
  addFuelData
} = logisticsSlice.actions;
export default logisticsSlice.reducer;

export const getTransportList = createAsyncThunk(
  "getTransportList",
  async (param) => {
    const res = await ItemService.generateLogisticsQuery(param);
    return res;
  }
);
export const getVehicleList = createAsyncThunk(
  "getVehicleList",
  async (param) => {
    const res = await ItemService.generateLogisticsQuery(param);
    return res;
  }
);
export const getDriverList = createAsyncThunk(
  "getDriverList",
  async (param) => {
    const res = await ItemService.generateLogisticsQuery(param);
    return res;
  }
);
export const getTransporterList = createAsyncThunk(
  "getTransporterList",
  async (param) => {
    const res = await ItemService.generateLogisticsQuery(param);
    return res;
  }
);
export const getBunkList = createAsyncThunk("getBunkList", async (param) => {
  const res = await ItemService.generateBunk(param);
  return res;
});

export const getBankList = createAsyncThunk("getBankList", async (param) => {
  const res = await ItemService.generateLogisticsQuery(param);
  return res;
});
